<div class="innerpage-fullwithbanner">
    <h2 class="bighead">Pending Approval</h2>
    <ul class="bread-crumbs">
        <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
        <li>Properties<span style="padding:8px;">|</span></li>
        <li>Pending Approval</li>
    </ul>
</div>
<div class="featuredproperties user-list-wrap section-margin">
    <div class="container container-lg min-heightcontainer">
        <div class="border-div list-box table-fixed margin0">
            <div class="tabstyle2 offerdetailstab-padding pos-relative">
                <ul class="switchingproperty margin-bottom-15 offerlistingtab">
                    <li [class.active]="activeTab === tab.DataEntry">
                        <a (click)="onTabClick(tab.DataEntry)">
                            Data Entry
                            <span *ngIf="activeTab === tab.DataEntry" class="countstyle">{{rowCount}}</span>
                        </a>
                    </li>
                    <li [class.active]="activeTab === tab.Salesforce">
                        <a (click)="onTabClick(tab.Salesforce)">
                            Salesforce
                            <span *ngIf="activeTab === tab.Salesforce" class="countstyle">{{rowCount}}</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="floatinghead clearfix">
                <div class="rightside clearfix" *ngIf="activeSubTab !== tab.Duplicates">
                    <div class="search-sec">
                        <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" [(ngModel)]="searchText" placeholder="Tenant/State/City/Brokerage/Property Id">
                        <i class="fa fa-search icon" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="rightside clearfix" *ngIf="activeSubTab !== tab.Duplicates">
                  <div class="select-dropdown multiselectdesign margin-right-15 multi-check-dropdown pull-right">
                    <!--<angular2-multiselect [data]="tableColumns" [(ngModel)]="selectedColumns" [settings]="defaultTypeSettings"></angular2-multiselect>-->
                    <mat-form-field>
                      <mat-select [(ngModel)]="selectedColumns" multiple placeholder="Select Columns">
                        <mat-select-trigger>
                          <span>Select Columns</span>
                        </mat-select-trigger>
                        @for (tableColumn of tableColumns; track tableColumn) {
                          <mat-option [value]="tableColumn.id" class="multi-dropdown-item">{{tableColumn.name}}</mat-option>
                        }
                        <mat-option class="matoptionnodata" *ngIf="tableColumns.length === 0" disabled>
                          Nothing found...
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="floatinghead be-tab-02 clearfix" *ngIf="activeTab === tab.Salesforce">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a [class.active]="activeSubTab === tab.NewProperty" href="javascript:void(0);" (click)="onSubTabClick(tab.NewProperty)" class="nav-link active">
                                New Listings
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [class.active]="activeSubTab === tab.Duplicates" href="javascript:void(0);" (click)="onSubTabClick(tab.Duplicates)" class="nav-link">
                                Matching Records
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="margin-bottom-15  margin-right-10 displayinlineblockdiv" style="float:left" *ngIf="activeTab === tab.DataEntry && activeSubTab !== tab.Duplicates">
                    <label class="select">
                        <select class="form-control" [(ngModel)]="selectedBulkAction" (change)="onActionSelect($event,Approve,Reject);" style="width:150px">
                            <option value="0">Bulk Actions</option>
                            <option value="1">Approve</option>
                            <option value="2">Reject</option>
                        </select>
                        <i></i>
                    </label>
                </div>
                <div class="margin-bottom-15  margin-right-10 displayinlineblockdiv" style="float:left" *ngIf="activeTab === tab.DataEntry && activeSubTab !== tab.Duplicates">
                    <label class="select">
                        <select class="form-control" [(ngModel)]="selectedBrokerage" (change)="onActionBrokerageSelect($event);" style="width:250px">
                            <option value="0">View All Brokerage</option>
                            <option [(ngValue)]="item.Id" *ngFor="let item of brokerageList">{{item.BrokerageName}}</option>
                        </select>
                        <i></i>
                    </label>
                </div>
                <p *ngIf="selectedRows?.length > 0" class="selected-rows-count pull-left be-tag-01" style="margin:3px 0 5px 5px">
                    {{selectedRows?.length}} row{{selectedRows?.length == 1 ? '':'s'}} selected
                    <a class="remove" tooltip="Remove Selection" href="javascript:void(0);" (click)="resetSelectedRows();"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                </p>
            </div>
            <div class="table-responsive" *ngIf="activeSubTab !== tab.Duplicates">
                <table class="table basictable row-border hover" id="dtTable" datatable [dtOptions]="dtOptions">
                    <thead>
                      <tr>
                        <th data-orderable="false" [hidden]="activeTab === tab.Salesforce">
                          <label class="custom-checkbox withoutlabel">
                            <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i>
                          </label>
                        </th>
                        <th style="width:50px;position:static; cursor:auto;" data-orderable="false" [hidden]="activeTab === tab.Salesforce">Action</th>
                        <th [hidden]="true">Property Id</th>
                        <th class="min-width-td sticky-left z-100">Tenant</th>

                        <th [hidden]="hideColumn(1)">State</th>
                        <th [hidden]="hideColumn(2)" style="min-width:80px;">City</th>
                        <th [hidden]="hideColumn(2)">Tenant Name</th>
                        <th [hidden]="hideColumn(2)">Guarantor Name</th>
                        <th [hidden]="hideColumn(3)">Property Type</th>
                        <th [hidden]="hideColumn(4)">Property Status</th>
                        <th [hidden]="hideColumn(5)">Brokerage</th>
                        <th [hidden]="activeTab === tab.Salesforce">OM</th>
                        <th [hidden]="hideColumn(6)">Source URL</th>
                        <th [hidden]="hideColumn(7)" class="whitespacenowrap">Asking Price</th>
                        <th [hidden]="hideColumn(8)" class="whitespacenowrap">CAP Rate</th>
                        <th [hidden]="hideColumn(9) || (activeTab === tab.Salesforce)">Update</th>
                        <th [hidden]="hideColumn(10)">Last Modified</th>
                      </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let row of approvalList;let i = index ">
                          <tr [class.portfoio-list]="row.IsPortfolio">
                            <td [hidden]="activeTab === tab.Salesforce">
                              <label class="custom-checkbox withoutlabel" style="z-index:0">
                                <input type="checkbox" [(ngModel)]="row.IsSelected" (change)="onCheckboxChange($event,row.PropertyId);" class="ng-pristine ng-valid ng-touched"><i></i>
                              </label>
                            </td>
                            <td class="whitespacenowrap" [hidden]="activeTab === tab.Salesforce">
                              <div class="d-flex">
                              <div class="btn-group" dropdown>
                                <button id="button-basic" dropdownToggle type="button" class="blueone dropdown-toggle"
                                        aria-controls="dropdown-basic" placement="top" tooltip="Action" container="body">
                                  <i class="fa fa-cog" aria-hidden="true"></i>
                                </button>
                                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu leftaligned-dropdown" role="menu" aria-labelledby="button-basic">
                                  <!--<li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModal($event,ApproveTenant,row.PropertyId,'deletemodal',actions.ApproveTenant)" *ngIf="!row.IsPortfolio && (!row.TenantId > 0||(row.GuarantorName!=null&&!row.GuarantorId>0))">Approve Tenant/Guarantor</a></li>-->
                                  <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModal($event,Approve,row.PropertyId,'deletemodal',actions.Approve)" *ngIf="row.IsPortfolio">Approve</a></li>
                                  <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModal($event,Approve,row.PropertyId,'deletemodal',actions.Approve)" *ngIf="!row.IsPortfolio">Approve Tenant/Guarantor</a></li>
                                  <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModal($event,Reject,row.PropertyId,'panlestyle',actions.Reject)">Reject</a></li>
                                </ul>
                                <a href="javascript:void(0);" class="blueone" container="body" tooltip="Quick Edit" (click)="openModalForQuickEdit(QuickEdit,'panlestyle',row.PropertyGuid,row.State,row.City,row.Brokerage,1)" placement="top" style="line-height:32px;">
                                  <i class="fa fa-pencil-square-o" style="font-size:18px;margin-left:3px;" aria-hidden="true"></i>
                                </a>
                                <a href="javascript:void(0);" container="body" class="blueone" *ngIf="row.HasDuplicate == 1 " tooltip="View Duplicates" (click)="openModalForDuplicates(DuplicateProperty,'panlestyle',row.PropertyId)" placement="top" style="line-height:32px;">
                                  <i class="fa fa-files-o" style="font-size:18px;" aria-hidden="true"></i>
                                </a>
                              </div>
                            </div>
                            </td>
                            <td class="sticky-left" [hidden]="true"><p class="d-flex">{{ row.PropertySequenceId }}</p></td>
                            <td class="sticky-left tool-tip-no-max-width">
                              <p class="d-flex">
                                <span style="position:static;margin-right:5px;" *ngIf="row.IsPortfolio" (click)="showPortfolioProperties(row.PropertyId, i)" class="btn-collapse" [class.span-open]="this.approvalList[i].ShowPortfolioProperties">
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                                </span>
                                <span style="position:static;margin-right:5px;" *ngIf="!row.IsPortfolio && (!row.TenantId > 0||(row.GuarantorName!=null&&!row.GuarantorId>0))" tooltip="Approval Needed" class="btn-collapse" placement="right">
                                  <i class="fa fa-shield" aria-hidden="true"></i>
                                </span>
                                <a href="javascript:void(0);" *ngIf="activeTab !== tab.Salesforce" routerLink="/dataentry-property/{{row.PropertyGuid}}" (click)="onRedirection();" [queryParams]="{'prevroute':'Pending Approval',link:'pending-approval-list', isPortfolio:row.IsPortfolio}">{{ row.Tenant!=null?row.Tenant:row.TenantName }}</a>
                                <a href="javascript:void(0);" *ngIf="activeTab === tab.Salesforce" routerLink="/property/{{row.PropertyGuid}}" (click)="onRedirection();" [queryParams]="{'prevroute':'Pending Approval',link:'pending-approval-list', isPortfolio:row.IsPortfolio}">{{ row.Tenant}}</a>
                              </p><sub>{{row.PropertySequenceId}}</sub>
                              <p>{{row.Address}}</p>
                            </td>

                            <td [hidden]="hideColumn(1)"><p>{{ row.State ? row.State : '-' }}</p></td>
                            <td [hidden]="hideColumn(2)"><p>{{ row.City ? row.City : '-' }}</p></td>
                            <td [hidden]="hideColumn(2)"><p>{{ row.TenantName ? row.TenantName : '-' }}</p></td>
                            <td [hidden]="hideColumn(2)"><p>{{ row.GuarantorName ? row.GuarantorName : '-' }}</p></td>
                            <td [hidden]="hideColumn(3)">
                              <p *ngIf="!row.PropertyType">-</p>
                              <p tooltip="{{row.PropertyType}}">{{commonService.GetPropertyTypeWithCount(row.PropertyType)}}</p>
                            </td>
                            <td [hidden]="hideColumn(4)"><p [ngClass]="{'redtextlabel':(row.PropertyStatus === 'Closed' || row.PropertyStatus === 'Sold'),'greentextlabel':row.PropertyStatus === 'Available','orangetextlabel':row.PropertyStatus === 'Under Contract','not-available':row.PropertyStatus === 'Not Available','Off-Market':row.PropertyStatus === 'Off-Market'}">{{ row.PropertyStatus }}</p></td>
                            <td [hidden]="hideColumn(5)"><p>{{ row.Brokerage ? row.Brokerage : '-' }}</p></td>
                            <td [hidden]="activeTab === tab.Salesforce">
                              <a *ngIf="row.OMFilePath" href={{row.OMFilePath}} download="Document.pdf" target="_blank" [ngClass]="{'border-link':(row.OMFilePath)}"><i *ngIf="row.OMFilePath" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>OM</a>
                              <p *ngIf="!row.OMFilePath">-</p>
                            </td>
                            <td [hidden]="hideColumn(6)">
                              <p *ngIf="!row.SourceURL">-</p>
                              <p *ngIf="row.SourceURL" style="margin:5px 0 0 -3px"><a href="javascript:void(0);" target="_blank" [href]="(row.SourceURL.includes('http') ? '' : '//') + row.SourceURL"><i class="fa fa-external-link" aria-hidden="true"></i> View Site</a></p>
                            </td>
                            <td [hidden]="hideColumn(7)" class="whitespacenowrap" *ngIf="!row.Unpriced"><p>{{ (row.AskingPrice>=0) ? '$ '+(row.AskingPrice |number:0) : '-'}}</p></td>
                            <td [hidden]="hideColumn(7)" class="whitespacenowrap"  *ngIf="row.Unpriced"><p>Unpriced</p></td>
                            <td [hidden]="hideColumn(8)">
                              <p *ngIf="row.capRateText == 'ZCF'">{{row.capRateText}}</p>
                              <p *ngIf="row.capRateText != 'ZCF'">{{ row.CapRate ? (row.CapRate +' %') :'-' }}</p>
                            </td>
                            <td [hidden]="hideColumn(9) || (activeTab === tab.Salesforce)">
                              <p *ngIf="!row.AuditTrailId">New Property</p>
                              <a class="blueone" href="javascript:void(0);" *ngIf="row.AuditTrailId" (click)="openModalForAuditTrailDetail(template,'commonmodal activitylogmodal',row.AuditTrailId)" placement="top" container="body" tooltip="Activity log detail"><i aria-hidden="true" class="icofont icofont icofont-info"></i></a>
                            </td>
                            <td [hidden]="hideColumn(10)" class="whitespacenowrap">
                              <p class="member-name" *ngIf="row.LastModifiedBy">
                                <i class="fa fa-user-circle-o" aria-hidden="true"></i> {{ row.LastModifiedBy ? row.LastModifiedBy : '-' }}
                              </p>
                              <p *ngIf="!row.LastModifiedBy">-</p>
                              <p>{{ Validation.convertUTCDateToLocalDate(row.LastModifiedDate)| date:'MM/dd/yyyy h:mm a'  }}</p>
                            </td>
                          </tr>
                            <ng-container *ngIf="this.approvalList[i].ShowPortfolioProperties">
                              <tr *ngFor="let propChild of row.PortfolioProperties; let k=index" (click)="selecteRow(k)" [class.tr-collapse]="this.approvalList[i].ShowPortfolioProperties">
                                <td [hidden]="activeTab === tab.Salesforce">
                                </td>
                                <td class="whitespacenowrap" [hidden]="activeTab === tab.Salesforce">
                                </td>
                                <td class="sticky-left">
                                  <p class="d-flex">
                                    <a href="javascript:void(0);" routerLink="/dataentry-property/{{propChild.Guid}}" (click)="onRedirection();" [queryParams]="{'prevroute':'Pending Approval',link:'pending-approval-list', isPortfolio:propChild.IsPortfolio}">{{ propChild.PropertyName }}</a>
                                  </p><sub>{{propChild.PropertySequenceId}}</sub>
                                  <p>{{propChild.Address}}</p>
                                </td>
                                <td [hidden]="true"><p>{{ propChild.PropertySequenceId }}</p></td>
                                <td [hidden]="hideColumn(1)"><p>{{ propChild.State }}</p></td>
                                <td [hidden]="hideColumn(2)"><p>{{ propChild.City }}</p></td>
                                <td><p>{{ propChild.TenantName }}</p></td>
                                <td><p>{{ propChild.GuarantorName }}</p></td>
                                <td [hidden]="hideColumn(3)"><p tooltip="{{propChild.PropertyType}}">{{commonService.GetPropertyTypeWithCount(propChild.PropertyType)}}</p></td>
                                <td [hidden]="hideColumn(4)"><p [ngClass]="{'redtextlabel':(propChild.PropertyStatus === 'Closed' || propChild.PropertyStatus === 'Sold'),'greentextlabel':propChild.PropertyStatus === 'Available','orangetextlabel':propChild.PropertyStatus === 'Under Contract','not-available':propChild.PropertyStatus === 'Not Available','Off-Market':propChild.PropertyStatus === 'Off-Market'}">{{ propChild.PropertyStatus }}</p></td>
                                <td [hidden]="hideColumn(5)"><p>{{ propChild.BrokerageName ? propChild.BrokerageName : '-' }}</p></td>
                                <td [hidden]="activeTab === tab.Salesforce">
                                  <a *ngIf="propChild.OMFilePath" href={{propChild.OMFilePath}} download="Document.pdf" target="_blank" [ngClass]="{'border-link':(propChild.OMFilePath)}"><i *ngIf="propChild.OMFilePath" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>OM</a>
                                  <p *ngIf="!propChild.OMFilePath">-</p>
                                </td>
                                <td [hidden]="hideColumn(6)">
                                  <p *ngIf="!propChild.SourceURL">-</p>
                                  <p *ngIf="propChild.SourceURL" style="margin:5px 0 0 -3px"><a href="javascript:void(0);" target="_blank" [href]="(propChild.SourceURL.includes('http') ? '' : '//') + propChild.SourceURL"><i class="fa fa-external-link" aria-hidden="true"></i> View Site</a></p>
                                </td>
                                <td [hidden]="hideColumn(7)" class="whitespacenowrap">
                                  <p *ngIf="!propChild.Unpriced">{{ (propChild.SalePrice>=0) ? '$ '+(propChild.SalePrice |number:0) : '-'}}</p>
                                  <p *ngIf="propChild.Unpriced">Unpriced</p>
                                </td>
                                <td [hidden]="hideColumn(8)" class="whitespacenowrap">
                                  <p *ngIf="propChild.capRateText == 'ZCF'">{{propChild.capRateText}}</p>
                                  <p *ngIf="propChild.capRateText != 'ZCF'">{{ propChild.CapRate ? (propChild.CapRate +' %') :'-' }}</p>
                                </td>
                                <td [hidden]="hideColumn(9) || (activeTab === tab.Salesforce)">
                                  <p *ngIf="!propChild.AuditTrailId">New Property</p>
                                  <a class="blueone" href="javascript:void(0);" *ngIf="propChild.AuditTrailId" (click)="openModalForAuditTrailDetail(template,'commonmodal activitylogmodal',propChild.AuditTrailId)" placement="top" container="body" tooltip="Activity log detail"><i aria-hidden="true" class="icofont icofont icofont-info"></i></a>
                                </td>
                                <td [hidden]="hideColumn(10)" class="whitespacenowrap">
                                  <p class="member-name" *ngIf="propChild.LastModifiedBy">
                                    <i class="fa fa-user-circle-o" aria-hidden="true"></i> {{ propChild.LastModifiedBy ? propChild.LastModifiedBy : '-' }}
                                  </p>
                                  <p *ngIf="!propChild.LastModifiedBy">-</p>
                                  <p>{{ Validation.convertUTCDateToLocalDate(propChild.LastModifiedDate)| date:'MM/dd/yyyy h:mm a'  }}</p>
                                </td>
                              </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                    <tfoot>
                        <tr *ngIf="approvalList?.length == 0&&!IsLoading">
                            <td colspan="12" class="odd no-data-available">
                                <div class="nodata">
                                    <i class="fa fa-exclamation-triangle icon"></i>
                                    <p>No Data Available</p>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="clearfix"></div>
            <div class="margin-top-10" *ngIf="activeSubTab === tab.Duplicates">
                <app-matching-listings></app-matching-listings>
            </div>
        </div>
    </div>
</div>

<ng-template #Approve>
    <div class="modal-body padding30">
        <div class="form-group">
            <h6 class="displayvalue" *ngIf="!isBulkAction">The {{isPortfolio ? "Portfolio" : "Property"}} <b>{{selectedProperty}}</b> will be moved to live listings. Are you sure you want to continue?</h6>
            <h6 class="displayvalue" *ngIf="isBulkAction">Are you sure you want to approve <b>{{approveContent}}</b> properties ?</h6>

        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRefApprove.hide()">CANCEL</button>
            <button class="btn btn-lg btn-success" (click)="changeStatus();">YES</button>
        </div>
    </div>
</ng-template>

<ng-template #ApproveTenant>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to approve Tenant/Guarantor ?</h6>

    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefApprove.hide()">CANCEL</button>
      <button class="btn btn-lg btn-success" (click)="addTenantGuarantor();">YES</button>
    </div>
  </div>
</ng-template>

<ng-template #QuickEdit>
    <app-quick-edit-property [selectedPropertyId]="selectedPropertyId" [quickEditDetails]="quickEditDetails" (closeModal)="closeModal($event)" [isDataEntryProperty]="isDataEntryProperty"></app-quick-edit-property>
</ng-template>

<ng-template #DuplicateProperty>
    <app-duplicate-property-list [PropertyId]="selectedPropertyIdForDuplicates" [prevRoute]="'PendingApprovals'" [modalRef]="modalRef" [Type]="2"></app-duplicate-property-list>
</ng-template>

<ng-template #Reject>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Reject {{isPortfolio ? "Portfolio" : "Property"}}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefApprove.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">
        <div class="form-group">
            <label class="form-label" *ngIf="!isBulkAction">The {{isPortfolio ? "Portfolio" : "Property"}} <b>{{selectedProperty}}</b> will be Rejected. Are you sure you want to continue ?</label>
            <label class="form-label" *ngIf="isBulkAction">Are you sure you want to reject <b>{{approveContent}}</b> properties ?</label>
        </div>
        <div class="form-group">
            <label class="form-label">Comments</label>
            <textarea class="form-control" [(ngModel)]="Comments" maxlength="200" rows="3"></textarea>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRefApprove.hide()">Cancel</button>
            <button class="btn btn-success btn-lg" (click)="changeStatus();">Reject</button>
        </div>
    </div>
</ng-template>

<ng-template #template class="pull-left">
    <app-audit-trail-details [modalRef]="modalRef" [auditTrailId]="AuditId"></app-audit-trail-details>
</ng-template>
